import { PageBreadcrumbs } from 'src/components'
import { useLocales } from 'src/locales'

import { ProductsCard } from '../components'

export const ProductsPage = () => {
  const { t } = useLocales()

  return (
    <PageBreadcrumbs
      title={t('medicine_register.products.title')}
      items={[
        {
          title: t('menu.medicines_register')
        },
        {
          title: t('medicine_register.products.title')
        }
      ]}
    >
      <ProductsCard />
    </PageBreadcrumbs>
  )
}
